.container {
    min-height: 60vh;
    background-color: #0e111a;

    background-repeat: no-repeat;
}

.macImg {
    width: 550px;
    height: 350px;
    object-fit: cover;
    position: relative;
    z-index: 2;
}

.titleContainer {
    position: relative;
    overflow: hidden;
    display: flex;
    height: 760px;
    justify-content: flex-start;
    align-items: center;
}

.titleContainerMob {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 760px;
    justify-content: center;
    align-items: center;
}

/* --- hero background layer --- */
.heroBg {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
}

.heroSvg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.heroFade {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 280px;
    background: linear-gradient(to bottom, rgba(14, 17, 26, 0) 0%, #0e111a 88%);
}

.heroAsset {
    position: absolute;
    left: 70%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 96%;
    max-width: 52%;
    object-fit: contain;
    z-index: 1;
    pointer-events: none;
}

/* the box of the phone image, the glass icons are placed inside of it */
.heroAssetBoxMob {
    position: relative;
    z-index: 1;
    width: 94%;
    max-width: 460px;
    margin-top: 24px;
}

.heroAssetMob {
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    object-fit: contain;
    pointer-events: none;
}

/* the phone takes the middle third of the image, the icons stay on its sides */
.heroAssetBoxMob .glassChat {
    left: 16%;
    top: 4%;
}

.heroAssetBoxMob .glassUser {
    left: 3%;
    top: 44%;
}

.heroAssetBoxMob .glassChart {
    left: 18%;
    bottom: 2%;
}

.heroAssetBoxMob .glassMic {
    right: 14%;
    top: 14%;
}

.heroAssetBoxMob .glassLock {
    right: 4%;
    bottom: 22%;
}

/* --- AboutProject composite visual --- */
.aboutStage {
    position: relative;
    width: 470px;
    height: 560px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.aboutGlow {
    position: absolute;
    width: 380px;
    height: 380px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(76, 110, 245, 0.35), rgba(76, 110, 245, 0) 68%);
    filter: blur(4px);
}

.aboutPhone {
    position: relative;
    width: 232px;
    height: 504px;
    border-radius: 36px;
    background: #0b0d14;
    border: 3px solid #1c2233;
    box-shadow: 0 34px 64px rgba(20, 30, 80, 0.28);
    transform: perspective(1300px) rotateY(-16deg) rotate(1deg);
    overflow: hidden;
}

.aboutNotch {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 74px;
    height: 20px;
    border-radius: 12px;
    background: #0b0d14;
    z-index: 2;
}

.aboutScreen {
    position: absolute;
    inset: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    border-radius: 30px;
    object-fit: cover;
    display: block;
}

.aboutTag {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 13px;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #eef1f6;
    box-shadow: 0 14px 30px rgba(20, 30, 80, 0.16);
    color: #2b3f9e;
    font-size: 13px;
    font-weight: 600;
    font-family: var(--font-body);
    white-space: nowrap;
    z-index: 3;
}

.aboutTag1 {
    top: 6%;
    right: 2%;
}

.aboutTag2 {
    top: 45%;
    right: -4%;
}

.aboutTag3 {
    bottom: 12%;
    left: 0;
}

.glassIcon {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 18px;
    background: rgba(76, 110, 245, 0.22);
    border: 1px solid rgba(160, 180, 255, 0.5);
    backdrop-filter: blur(6px);
    box-shadow: 0 12px 30px rgba(40, 60, 160, 0.4);
}

.glassChat {
    width: 58px;
    height: 58px;
    left: 50%;
    top: 14%;
}

.glassUser {
    width: 56px;
    height: 56px;
    left: 51%;
    top: 43%;
}

.glassChart {
    width: 58px;
    height: 58px;
    left: 49%;
    bottom: 16%;
}

.glassMic {
    width: 64px;
    height: 64px;
    right: 15%;
    top: 15%;
}

.glassLock {
    width: 58px;
    height: 58px;
    right: 19%;
    bottom: 24%;
}

.titleContent, .titleContentMob {
    position: relative;
    z-index: 2;
}


.title {
    font-size: 5.3em;
    font-family: var(--font-display);
    margin: 0;
    color: white;
    text-align: justify;
    font-weight: 1000;
}

.titleContent {
    padding-left: 8%;
}

/* the mobile layout is one column, the title block is centered in it */
.titleContentMob {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-self: center;
    align-items: center;
    text-align: center;
}

.titleContentMob .title {
    text-align: center;
}

.description {
    display: block;
    font-family: var(--font-serif);
    font-size: 2em;
    margin-top: 13px;
    font-style: italic;
    color: white;
    font-weight: 500;
}

.workDescriptionBox {
    display: flex;
    justify-content: center;
}

.workDescription {
    margin: 0;
    max-width: 500px;
    min-width: 300px;
    font-size: 1em;
    /*background-color: red;*/
    word-spacing: 5px;
    text-align: justify-all;
    line-height: 28px;
    font-family: var(--font-serif);
}

.workDescription strong {
    color: #f06449;
}


@media (max-width: 1200px) {
    .titleContainerMob {
        box-sizing: border-box;
        height: auto;
        min-height: 760px;
        padding: 40px 16px;
    }
}

@media (max-width: 600px) {
    .title {
        font-size: 3.4em;
    }

    .description {
        font-size: 1.4em;
    }

    .workDescription {
        min-width: 0;
    }

    .heroAssetBoxMob .glassIcon {
        width: 46px;
        height: 46px;
        border-radius: 14px;
    }

    .heroAssetBoxMob .glassIcon svg {
        width: 22px;
        height: 22px;
    }
}
